import '../css/main.css'
import './lenis'

import { initDestinationCarousel } from './modules/destination-carousel'
import { initFloorplanZoom } from './modules/floorplan-zoom'
import { initGalleryCarousel } from './modules/gallery-carousel'
import { initModals } from './modules/modals'
import { initNav } from './modules/nav'
import { initRegistrationScroll } from './modules/registration-scroll'
import { initTabs } from './modules/tabs'
import { initViewTransitions } from './modules/view-transitions'

initNav()
initRegistrationScroll()
initViewTransitions()
initModals()
initDestinationCarousel()
initTabs()
initFloorplanZoom()
initGalleryCarousel()
